import { Dispatch, ReactElement, SetStateAction, useRef } from 'react';

import { FiX } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { CSSProperties } from 'styled-components';

import { ModalInfo, Button } from '~/components';
import { light } from '~/styles/themes';
import LifesService from '~/services/lifes';

interface IConfirmDeleteLivesModalProps {
  modalIsVisible: boolean;
  setModalIsVisible: Dispatch<SetStateAction<boolean>>;
  leadId: string;
  onSuccess?: () => void;
}

function ConfirmDeleteLivesModal({
  modalIsVisible,
  setModalIsVisible,
  leadId,
  onSuccess,
}: IConfirmDeleteLivesModalProps): ReactElement {
  const modalContainerStyle = useRef<CSSProperties>({
    position: 'relative',
    padding: '4.8rem',
    textAlign: 'center',
  });

  const modalCloseButtonStyle = useRef<CSSProperties>({
    background: 'none',
    position: 'absolute',
    top: '30px',
    left: '30px',
  });

  const buttonGroupStyle = useRef<CSSProperties>({
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    marginTop: '2rem',
  });

  const submitButtonStyle = useRef<CSSProperties>({ borderRadius: '10px' });

  const handleCloseModal = (): void => {
    setModalIsVisible(false);
  };

  const handleConfirm = async (): Promise<void> => {
    try {
      await LifesService.deleteLife(leadId);
      toast.success('Vida deletada com sucesso');
      handleCloseModal();
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error('Erro ao deletar as vidas');
    }
  };

  return (
    <ModalInfo
      modalVisible={modalIsVisible}
      setModalVisible={setModalIsVisible}
      containerStyle={modalContainerStyle.current}
    >
      <button
        type="button"
        onClick={handleCloseModal}
        title="Fechar modal"
        style={modalCloseButtonStyle.current}
      >
        <FiX color={light.colors.primary} size={30} />
      </button>
      <h2 style={{ marginBottom: '-30px', color: '#555' }}>
        Tem certeza que deseja deletar a vida?
      </h2>
      <div style={buttonGroupStyle.current}>
        <Button
          type="button"
          containerStyle={submitButtonStyle.current}
          onClick={handleCloseModal}
        >
          Cancelar
        </Button>
        <Button
          type="button"
          containerStyle={submitButtonStyle.current}
          onClick={handleConfirm}
        >
          Deletar
        </Button>
      </div>
    </ModalInfo>
  );
}

export default ConfirmDeleteLivesModal;
